module.exports = "https://static.energy5.com/_next/static/images/cert4-11867f92ef9c24c274d77365139d5cd1.png";